export default __webpack_public_path__ + "static/media/casino_live_poker.28df7759.png";